
import { Ctx } from "@/components/FormContent/FormContent";
import {
  openForm,
  relativeTime,
  formatDate,
} from "@/components/FormContent/methods";
import EmptyState from "@/components/ui/EmptyState.vue";
import { useStore } from "@/store";

const store = useStore();

export default {
  components: { EmptyState },
  computed: {
    messages() {
      return store.messages;
    },
  },
  methods: {
    relativeTime,
    formatDate,
    messageClick(message) {
      message.new = false;
      const { formname, filter } = message;
      openForm(
        {} as Ctx,
        { form_header: message.form_title, formname, filter },
        null
      );
    },
  },
};
